import { Action } from "@ngrx/store";

export const CHANGE_TO_CNP_CHANNEL = "CHANGE_TO_CNP_CHANNEL";
export const CHANGE_TO_CP_CHANNEL = "CHANGE_TO_CP_CHANNEL";
export const CHANGE_TO_WHATSAPP_CHANNEL = "CHANGE_TO_WHATSAPP_CHANNEL";

export class Change_To_CNP_Channel_Action implements Action {
  readonly type = CHANGE_TO_CNP_CHANNEL
}

export class Change_To_CP_Channel_Action implements Action {
  readonly type = CHANGE_TO_CP_CHANNEL
}

export class Change_To_WHATSAPP_Channel_Action implements Action {
  readonly type = CHANGE_TO_WHATSAPP_CHANNEL
}